import * as z from "zod";

export const recipeBoxBaseSchema = z.object({
  title: z
    .string()
    .min(1, "Title is required.")
    .max(80, "Title must be 80 characters or fewer."),
  description: z
    .string()
    .max(300, "Description must be 300 characters or fewer.")
    .optional(),
});

export type RecipeBoxFormValues = z.infer<typeof recipeBoxBaseSchema>;

